const isNull = (value) => {
	return value === null;
};

export default isNull;
